import VulnerabilityDetailsAssetTable from './VulnerabilityDetailsAssetTable';

export default VulnerabilityDetailsAssetTable;
export { VulnerabilityDetailsAssetTable };
